<div class="dealership-even-align">

<div class='dealer-capacity-container'>
    <div class='capacity-header'>
        {{'departmentCapacity.serviceCapacitySetup'| translate}}
        <div class="controls" *ngIf="viewMode == 'Shop'">
            <div class="cancel"(click)="onCancelClicked()" 
            [ngClass]="isShopMaxSlotsPerDayEdited ||isShopMaxSlotsPerTimePeriodEdited ?'enabled':''">
            {{'overrideCapacity.cancel'| translate}}
            </div>
            <div class="save" (click)="onSaveClicked()" 
            [ngClass]="isShopMaxSlotsPerDayEdited ||isShopMaxSlotsPerTimePeriodEdited ?'enabled':''">
            {{'overrideCapacity.save'| translate}}
            </div>
        </div>
    </div>

    <div style="padding:1rem 1rem 0">
        <app-shop-max
        [viewMode]="viewMode"
        [saveClicked]="isShopMaxPerTimeDaySaveClicked"
        [cancleClicked]="isCancelClicked"
        (formEdited)="shopMaxSlotsPerDayFormEdited($event)"
        (cancleClick)="resetCancleClickValue($event)"
        (saveClick)="resetSaveClickedValue($event)">
        </app-shop-max>
    </div>
    <div class='capacity-options'>
        <div class='capacity-view' [ngClass]="viewMode == 'Shop' ? 'selected':''" (click)="formsEdited()?showAlert('Shop'):loadView('Shop')">{{'departmentCapacity.shopSlots'| translate}}
        </div>
        <div class='capacity-view' [ngClass]="viewMode == 'Team' ? 'selected':''" (click)="formsEdited()?showAlert('Team'):loadView('Team')">{{'departmentCapacity.teamSlots'| translate}}
        </div>
    </div>
</div>

<ng-container *ngIf="viewMode == 'Shop'">
    <div style="display: inline-block;margin-bottom: 10px;width:100%;padding:0 1rem 0 1rem">
        <div style="float: left;">{{'departmentCapacity.shopSlots'| translate}}</div>
        <div style="float: right;">
            <div style="float: left;font-size: 12px;padding-right: 5px;padding-top: 4px;">{{'departmentCapacity.activate'| translate}}</div>
            <div style="float: right;position:relative;"><app-onofswitch [switchInput]='true'></app-onofswitch> <div class="readonly-layer"></div></div>
        </div>
    </div>
    <div style="padding-left:1rem">
      {{'departmentCapacity.shopMaxSlotsPerTimePeriod'| translate}}
        <div  class="table-value-info">
            <div>
            <span class="material-icons" >info</span></div>
            <div class="d-flex" *ngFor="let info of tableValueInfo; last as isLast">
                <div>{{ info.value | translate}}</div> &nbsp; -  &nbsp;<div>{{info.description | translate }}</div>
                <div class="dot-space" *ngIf="!isLast"> | </div> 
            </div>
        </div>
    </div>
    <div style="padding:1rem; overflow-y: auto;">
        <app-timeslot-grid *ngIf="masterSlotsLoading$ | async"
            [viewMode]="viewMode"
            [slotDetails$] = "slotDetails$ | async"
            [maxAndMasterSlots$] = "maxAndMasterSlots$ | async"
            (saveChanges)="onSaveChanges($event)"
            [switchInput]=true
            [saveClicked]="isSavedClicked"
            (formEdited)="shopMaxSlotsPerTimeTableFormEdited($event)"
            [cancleClicked]="isShopMaxSlotsPerTimePeriodCancleClicked"
            (cancleClick)="resetCancleClickedPerTimePeriod($event)"
            [department]="department">
            </app-timeslot-grid>
    </div>
</ng-container>

<ng-container *ngIf="viewMode == 'Team'">
    <div style="display: inline-block;width:100%;padding:0 1rem 0 1rem;">
        <div style="float: left;">{{'departmentCapacity.teamSlots'| translate}}</div>
        <div style="float: right;">
            <div style="float: left;font-size: 12px;padding-right: 5px;padding-top: 4px;">{{'departmentCapacity.activate'| translate}}</div>
            <div style="float: right;"><app-onofswitch [switchInput]='teamActivate' (switchChange)="updateSwitchValues($event, 'team')"></app-onofswitch></div>
        </div>
    </div>
    <div style="padding:1rem">
      {{'departmentCapacity.teamMaxSlotsPerDay'| translate}}
    </div>

    <app-team-max [switchInput]='teamActivate' 
    [viewMode]="viewMode" 
    [teams$]="teams$ | async" [totals$]="teamMaxTotal$ | async"
    [saveClicked]="isTeamMaxPerTimeDaySaveClicked"
    [cancleClicked]="isTeamMaxSlotsPerTimePeriodCancleClicked"
    (formEdited)="teamMaxSlotsPerDayEdited($event)"
    (cancleClick)="resetCancleClickedTeamPerTimePeriod($event)"
    (saveClick)="teamMaxSlotsPerDaySaveReset($event)"
    [allFormsEdited]="allFormsEdited"
    >
    </app-team-max>
    <div style="padding-left:1rem">
        {{'departmentCapacity.teamMaxSlotsPerTimePeriod'| translate}}
      </div>
    <div style="margin:1rem" *ngFor="let team of teams$ | async">
        <mat-expansion-panel (opened)="selectedTeam = team" style="overflow: inherit !important;">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span>{{team.name}}</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <app-timeslot-grid *ngIf="masterSlotsLoading$ | async"
            [viewMode]="viewMode"
            [team]="team"
            [slotDetails$] = "getTeamSlotDetails(team) | async"
            [maxAndMasterSlots$] = "maxAndMasterSlots$ | async"
            (saveChanges)="onSaveChanges($event)"
            [switchInput]='teamActivate'
            [saveClicked]="isSavedClicked"
            (formEdited)="shopMaxSlotsPerTimeTableFormEdited($event)"
            [cancleClicked]="isShopMaxSlotsPerTimePeriodCancleClicked"
            (cancleClick)="resetCancleClickedPerTimePeriod($event)"
            [department]="department">
            </app-timeslot-grid>
        </mat-expansion-panel>
    </div>

</ng-container>
</div>